export const replaceElement = ({
  target,
  html
}: {
  target: Element
  html: string
}): Element => {
  const parent = target.parentNode
  if (!parent) {
    throw new Error('Target must be in the document')
  }
  const targetIndex = Array.prototype.indexOf.call(parent.children, target)
  target.outerHTML = html
  const updatedTarget = parent.children[targetIndex]
  return updatedTarget
}

export const appendElement = ({
  parent,
  html
}: {
  parent: Element
  html: string
}): Element => {
  let newElement: Element = document.createElement('div')
  parent.appendChild(newElement)
  newElement = replaceElement({
    target: newElement,
    html
  })
  return newElement
}

export const setChildContent = ({
  parent,
  selector,
  html
}: {
  parent: Element
  selector: string
  html: string
}): void => {
  const element = parent.querySelector(selector)
  if (element) {
    element.innerHTML = html
  }
}

export const toggleChildAttribute = ({
  parent,
  selector,
  attributeName,
  attributePresent
}: {
  parent: Element
  selector: string
  attributeName: string
  attributePresent: boolean
}): void => {
  const element = parent.querySelector(selector)
  if (element && attributePresent) {
    element.setAttribute(attributeName, '')
  } else if (element && !attributePresent) {
    element.removeAttribute(attributeName)
  }
}

export const setChildAttribute = ({
  parent,
  selector,
  attributeName,
  attributeValue
}: {
  parent: Element
  selector: string
  attributeName: string
  attributeValue: string
}): void => {
  const element = parent.querySelector(selector)
  if (element) {
    element.setAttribute(attributeName, attributeValue)
  }
}

export const setChildStyle = ({
  parent,
  selector,
  property,
  value
}: {
  parent: Element
  selector: string
  property: string
  value: string
}): void => {
  const element = parent.querySelector(selector) as HTMLElement
  if (element) {
    element.style.setProperty(property, value)
  }
}

export const toggleChildClass = ({
  parent,
  selector,
  className,
  classPresent
}: {
  parent: Element
  selector: string
  className: string
  classPresent: boolean
}): void => {
  if (classPresent) {
    addChildClass({ parent, selector, className })
  } else {
    removeChildClass({ parent, selector, className })
  }
}

export const addChildClass = ({
  parent,
  selector,
  className
}: {
  parent: Element
  selector: string
  className: string
}): void => {
  const element = parent.querySelector(selector)
  if (element) {
    element.classList.add(className)
  }
}

export const removeChildClass = ({
  parent,
  selector,
  className
}: {
  parent: Element
  selector: string
  className: string
}): void => {
  const element = parent.querySelector(selector)
  if (element) {
    element.classList.remove(className)
  }
}
